import "core-js/stable"
import * as Sentry from "@sentry/browser"

import bootstrap, { isModuleEntry } from "./lib/bootstrap"

Sentry.init({
  dsn: "https://10a6b09e4c17439b8402aa578f7a9df3@o76841.ingest.sentry.io/5752635",
  environment: window.location.hostname,
})

function init(): void {
  const modulesSource = document.querySelector(
    // this selector must match the one used by airship
    "script[data-airship-brand-page-modules]"
  )

  if (!modulesSource?.textContent)
    throw new Error("Brand page modules not available")

  const modules = JSON.parse(modulesSource.textContent)

  modules.forEach((module: unknown) => {
    if (!isModuleEntry(module))
      throw new Error(`Invalid module entry: ${module}`)
    bootstrap(module)
  })
}

if (document.readyState === "complete") {
  init()
} else {
  window.addEventListener("DOMContentLoaded", init)
}
